import React from 'react';

const WidgetConsignesSvg = ({width = 20, height = 20, couleur = "#A8B0B3"}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 40 40" fill="none">
        <path d="M11 8C8.74364 8 7 8 7 8V37H33V8L29 8" stroke={couleur} strokeWidth="4"/>
        <rect x="13" y="4" width="14" height="8" stroke={couleur} strokeWidth="4"/>
    </svg>
);

export default WidgetConsignesSvg;
